import { useInfiniteQuery } from '@tanstack/react-query';

import { getCurrentISOString } from 'utils/date.utils';

import { useLocale } from 'hooks/useLocale';

import { sortByStartDateTime } from 'components/@events/utils';

import { cityEventsQuery } from './queries';

interface Props {
  eventsPerPage: number;
  slug: string;
}

export const useInfiniteEventsCity = ({ eventsPerPage, slug }: Props) => {
  const { locale } = useLocale();

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery(
    cityEventsQuery(
      {
        locale,
        slug,
        currentISOString: getCurrentISOString(),
        orderBy: 'startDatetime_ASC',
      },
      eventsPerPage,
    ),
  );

  const unfilteredEvents = data?.pages.flatMap((page) => page.events);
  const events = unfilteredEvents?.sort((a, b) =>
    sortByStartDateTime(a, b, 'asc'),
  );

  return {
    events,
    fetchNextPage,
    hasNextPage,
    isFetching,
  };
};
